import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { removeOtpData, saveToHistory, setOtpPhone } from '../cellcomAbroadBlockSlice';
import './SubscriberDetailsHeader';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import { resetAuth, clearHistory } from '../../../../utilities/authentication/authenticationSlice';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';

function SubscriberDetailsHeader({
  subscriber,
  isJETAuthentication,
  removeOtpData,
  saveToHistory,
  isBusinessIndividual,
  changeAccountBusinessIndividual,
  resetAuth,
  relatedPhoneNumbers,
  isLoginAuthentication,
  validateExistedPackages,
  setOtpPhone,
  otpPhone,
  selectedSelfcareSubscriber,
  clearHistory
}) {

  useEffect(() => {
    if (isLoginAuthentication) {
      if (relatedPhoneNumbers.length > 0 && selectedSelfcareSubscriber !== null && relatedPhoneNumbers.includes(selectedSelfcareSubscriber)) {
        setAndValidatePhone(selectedSelfcareSubscriber);
      }
    }
  }, [relatedPhoneNumbers]);

  function disconnectUser() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_DISCONNECT_MY_ACCOUNT.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_DISCONNECT_MY_ACCOUNT.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_DISCONNECT_MY_ACCOUNT.eventParams
    );
    resetAuth();
    removeOtpData();
    saveToHistory();
    clearHistory();
  }

  function getText() {
    const text = isBusinessIndividual ? 'החלף מנוי' : 'התנתקות';
    return text;
  }

  const getSelectPlaceHolder = () => {
    if (otpPhone && relatedPhoneNumbers.length > 0 && relatedPhoneNumbers.includes(otpPhone)) {
      return otpPhone;
    } else {
      return 'בחר מנוי';
    }
  };

  const setAndValidatePhone = (phone) => {
    setOtpPhone(phone);
    validateExistedPackages(phone);
    document.getElementsByClassName('packageExists')[0]?.classList.add('packageTabLoader', 'not-validated');
  };

  return (
    <div className='row subscriber-details-box-container'>
      <div className='header'>
        ניהול חבילות <span className='bold-txt'>חו"ל שלי</span>
      </div>
      <div className={`subscriber-box  ${isLoginAuthentication ? 'd-flex flex-wrap align-items-center' : ''}`}>
        {(isLoginAuthentication && relatedPhoneNumbers?.length > 1 && !isBusinessIndividual) ||
          (relatedPhoneNumbers?.length == 1 && !relatedPhoneNumbers.includes(selectedSelfcareSubscriber ?? subscriber)) ? (
          <>
            <span className='subscriber mb-10'>מנוי</span>
            <ReactSelect
              getOptionLabel={(option) => option}
              getOptionValue={(option) => option}
              placeholder={getSelectPlaceHolder()}
              value={(option) => option}
              name='selected'
              options={relatedPhoneNumbers}
              onChange={(phone) => setAndValidatePhone(phone)}
            />
          </>
        ) : (
          <div className='subscriber'>מנוי {subscriber ?? selectedSelfcareSubscriber}</div>
        )}

        <div
          className={`unsubscribe  ${isLoginAuthentication && relatedPhoneNumbers?.length > 1 ? 'mb-10' : ''}`}
          onClick={() => (isBusinessIndividual ? changeAccountBusinessIndividual() : disconnectUser())}>
          {' '}
          {!isJETAuthentication ? getText() : null}
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  removeOtpData,
  resetAuth,
  saveToHistory,
  setOtpPhone,
  clearHistory
};

const mapStateToProps = (state) => {
  return {
    subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    isJETAuthentication: state.cellcomAbroad.isJETAuthentication,
    otpPhone: state.cellcomAbroad.otpData.otpPhone,
    relatedPhoneNumbers: state.cellcomAbroad.relatedPhoneNumbers,
    selectedSelfcareSubscriber: state.selfcarePage.selectedSubscriber?.productSubscriberNo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberDetailsHeader);
